import numeral from "numeral";

const regexp = ({ props }) => {
    let pattern = `\\d{0,${props.maxDecimal}}`;
    if (props.allowPrecision) {
        pattern += `(\\.\\d{0,${props.maxPrecision}})?`;
    }
    if (props.allowMinus) {
        pattern = `(-)?${pattern}`;
    }
    return new RegExp(`^${pattern}$`, "i");
};

export const formatInputValue = ({ props, data }) => {
    const valueStr = props.value !== undefined && props.value !== null ? props.value.toString() : "";
    if (!valueStr) {
        return "";
    }
    if (data.focus) {
        return valueStr.replace(/,/g, "");
    }
    let postfix = "";
    let format = "";
    if (props.comma) {
        format += "0,0";
    } else {
        format += "0";
    }
    if (props.allowPrecision) {
        let num = 0;
        if (valueStr.indexOf(".") >= 0) {
            num = valueStr.substring(valueStr.indexOf(".") + 1).length;
        }
        if (num > 0) {
            format += ".";
            for (let i = 0; i < num; ++i) {
                format += "0";
            }
        }
        if (!data.focus && props.autoPrecision) {
            if (!valueStr.endsWith(".")) {
                format += ".";
            }
            for (let i = num; i < props.maxPrecision; ++i) {
                format += "0";
            }
        }
        if (valueStr.endsWith(".")) {
            postfix = ".";
        }
    }
    if (props.allowLeadZero) {
        format = format.substring(1);
        let zero = "";
        for (let i = 0; i < valueStr.length; ++i) {
            const at = valueStr.substring(i, i + 1);
            if (at === ".") {
                break;
            }
            if (at !== "-") {
                zero += "0";
            }
        }
        format = zero + format;
    }
    return numeral(valueStr).format(format) + postfix;
};

export const onUpdateValue = ({ props, emit }) => {
    return value => {
        value = value.replace(/,/g, "");
        if (regexp({ props }).test(value)) {
            emit("update:value", value);
        }
    };
};

export const createOnBlur = ({ data, emit }) => {
    return () => {
        data.focus = false;
        emit("blur");
    };
};
